import {
  SignUpForm,
  signUpFormConstraints,
  SignUpPageProps
} from './sign-up-page.types'
import { SignUpPage as SignUpPageUI } from '@touche-lts/panel-ui/dist/components/pages/sign-up-page'
import styles from './sign-up-page.module.scss'
import { useState } from 'react'
import { validate } from 'validate.js'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'

const SignUpPageComponent = (props: SignUpPageProps) => {
  const {
    className,
    style,
    match: {
      params: { code }
    }
  } = props

  const [formState, setFormState] = useState<SignUpForm>({
    firstName: '',
    lastName: '',
    password: '',
    confirmPassword: ''
  })

  const {
    userStore: { signUp }
  } = useRootStore()

  const onSignUpClick = () => {
    signUp(code, {
      firstName: formState.firstName.trim(),
      lastName: formState.lastName.trim(),
      password: formState.password
    })
  }

  return (
    <SignUpPageUI
      className={className}
      style={{ backgroundColor: styles.primaryContent, ...style }}
      firstNameValue={formState.firstName}
      onFirstNameChange={firstName => setFormState(s => ({ ...s, firstName }))}
      lastNameValue={formState.lastName}
      onLastNameChange={lastName => setFormState(s => ({ ...s, lastName }))}
      passwordValue={formState.password}
      onPasswordChange={password => setFormState(s => ({ ...s, password }))}
      confirmPasswordValue={formState.confirmPassword}
      onConfirmPasswordChange={confirmPassword =>
        setFormState(s => ({ ...s, confirmPassword }))
      }
      submitButtonProps={{
        children: 'Sign up',
        onClick: onSignUpClick,
        disabled: validate(formState, signUpFormConstraints)
      }}
    />
  )
}

const SignUpPage = observer(SignUpPageComponent)
export { SignUpPage }
